import { computed } from 'vue';
import { useFlag } from '@/composables/useFlag';

const IS_MAINTENANCE_MODE = Boolean(import.meta.env.VITE_MAINTENANCE_MODE);

export function useMaintenanceMode() {
  const maintenanceModeBypass = useFlag('maintenance-mode-bypass');
  const maintenanceMode = useFlag('maintenance-mode');

  return computed(
    () =>
      !maintenanceModeBypass.value &&
      (IS_MAINTENANCE_MODE || maintenanceMode.value)
  );
}
